<svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
  <rect width="28" height="28" rx="8" fill="#D14905" />
  <path
    d="M23.7607 18.7461L13.8298 22.5586L4.20902 18.746L13.8296 15.2267L23.7607 18.7461Z"
    fill="white"
    stroke="#D14905"
  />
  <path
    d="M23.9405 13.8239L13.8302 18.3522L4.03567 13.8238L13.83 9.64388L23.9405 13.8239Z"
    fill="white"
    stroke="#D14905"
  />
  <path
    d="M23.7607 8.9492L13.8298 12.7618L4.20902 8.94913L13.8296 5.42986L23.7607 8.9492Z"
    fill="white"
    stroke="#D14905"
  />
</svg>
